import { FieldType, ViewModelBase } from "@shoothill/core";
import { RDDV2StatusModel } from "./RDDV2StatusModel";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";

export class RDDV2StatusViewModel extends ViewModelBase<RDDV2StatusModel> {
    public constructor(rddV2Id: string | null) {
        super(new RDDV2StatusModel(), false);
        this.setDecorators(RDDV2StatusModel);
        this.model.rddV2Id = rddV2Id!;
    }

    public server: ServerViewModel = new ServerViewModel();

    public async isFieldValid(fieldName: keyof FieldType<RDDV2StatusModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        errorMessage = "";
        isValid = true;

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
